module.exports = __webpack_public_path__ + "static/media/ico-darkmode.544613cb.svg";